<template>
	<div>
		<template v-if="isMultiblock == 'true'">
			<GalleryItemComponent :pictureData="pictureData" :index="index" :pictureKey="pictureKey" isMultiblock="true" />
		</template>
	
		<template v-else>
			<section :id="['container-' + index + '-' + pictureData.type]" :class="['container-' + pictureData.type]">
				<GalleryItemComponent :pictureData="pictureData" :index="index" :pictureKey="pictureKey" isMultiblock="false" />
			</section>
			<hr class="horizontal-line">
		</template>
	</div>
</template>

<script>
import GalleryItemComponent from './GalleryItemComponent.vue'

export default {
	components: {
		GalleryItemComponent,
	},

	props: {
		pictureData: {
			type: Object
		},
		pictureKey: {
			type: Number
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/galleryComponent.scss";
</style>